var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBurger(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.89905 3.6C1.89905 3.4067 2.05575 3.25 2.24905 3.25H9.74905C9.94235 3.25 10.099 3.4067 10.099 3.6C10.099 3.7933 9.94235 3.95 9.74905 3.95H2.24905C2.05575 3.95 1.89905 3.7933 1.89905 3.6ZM1.90002 6.00039C1.90002 5.80709 2.05672 5.65039 2.25002 5.65039H9.75002C9.94332 5.65039 10.1 5.80709 10.1 6.00039C10.1 6.19369 9.94332 6.35039 9.75002 6.35039H2.25002C2.05672 6.35039 1.90002 6.19369 1.90002 6.00039ZM2.25002 8.05078C2.05672 8.05078 1.90002 8.20748 1.90002 8.40078C1.90002 8.59408 2.05672 8.75078 2.25002 8.75078H9.75002C9.94332 8.75078 10.1 8.59408 10.1 8.40078C10.1 8.20748 9.94332 8.05078 9.75002 8.05078H2.25002Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurger);
export default __webpack_public_path__ + "static/media/burger.024b35c0.svg";
export { ForwardRef as ReactComponent };